import React from 'react';

import * as Icon from 'ubs-icons';

import NoLinks from '../images/no-links';

const UDownload = (props) => {

    document.addEventListener('mouseup', function(e) {
        var container = document.querySelector('.u_download-version');
        if(document.querySelector('.u_download-version')) {
            if (!container.contains(e.target)) {
                document.querySelectorAll('.u_download-version-list')?.forEach(_=> {
                    _?.classList.add('u_hidden');
                })
            }
        }
    });

    const openList = (appClass) => {
        document.querySelector(`.u_download-version-list.u_download-version-${appClass || ""}`).classList.toggle('u_hidden')
    }

    const downloadLink = (link) => {
        window.open(link, '_blank');
        openList();
    }

    return (
        <React.Fragment>

            <div className="u_download-app">

                <div className="u_download-app-icon">
                    <div className="u_download-app-icon-inner">
                        <Icon.UBS/>
                    </div>
                </div>

                <h4>Download Our Latest App</h4>
            </div>
            
            {
                Object.keys(props?.downloadData)?.length !== 0 ? 
                Object.values(props?.downloadData)?.map(value => value?.hasOwnProperty('link') ? value?.link : '')?.every(link => link === '') 
                    ? <div className="u_download-container u_download-no-links">
                        <NoLinks />
                        <h3>There is no update available.</h3>
                    </div>
                    : <div className="u_download-container">

                {(props?.downloadData?.chatWindows32?.link?.length !== 0 || props?.downloadData?.chatWindows64?.link?.length !== 0 || props?.downloadData?.chatMac?.link?.length !== 0 || props?.downloadData?.chatLinux?.link?.length !== 0) &&
                <div className="u_download-wpr">

                    <div className="u_download-header">
                        <h5>Super Chat - Desktop App</h5>
                    </div>

                    <div className="u_download-section">
                        {(props?.downloadData?.chatWindows32?.link?.length !== 0 || props?.downloadData?.chatWindows64?.link?.length !== 0) && <div className="u_download-block">
                            <div className="u_download-block-icon">
                                <Icon.WindowsColor size={34}/>
                            </div>
                            <p>Windows</p>
                            <div className="u_download-version">
                                <button className="u_download-block-btn" onClick={() => openList("chat")}>
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                    <span className="u_download-block-arrow"><Icon.DownArrow fill="#007AFF" size={12}/></span>
                                </button>

                                <ul className="u_hidden u_download-version-list u_download-version-chat">
                                    {
                                        props?.downloadData?.chatWindows32?.link?.length !== 0 && <li>
                                            <a href="javascript:;" onClick={() => downloadLink(props?.downloadData?.chatWindows32?.link)}>
                                                <span> <Icon.Windows fill="#4E525F" size={14}/></span>
                                                Windows 32
                                            </a>
                                        </li>
                                    }
                                    {
                                        props?.downloadData?.chatWindows64?.link?.length !== 0 && <li>
                                            <a href="javascript:;" onClick={() => downloadLink(props?.downloadData?.chatWindows64?.link)}>
                                                <span> <Icon.Windows fill="#4E525F" size={14}/></span>
                                                Windows 64
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>

                        </div>}
                        {
                            props?.downloadData?.chatMac?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.Apple fill="#1E2538" size={34}/>
                                </div>
                                <p>Mac</p>
                                <a href={props?.downloadData?.chatMac?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }

                        {
                            props?.downloadData?.chatLinux?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.Linux size={34}/>
                                </div>
                                <p>Linux</p>
                                <a href={props?.downloadData?.chatLinux?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                    </div>
                </div>
                }

                {(props?.downloadData?.trackWindows32?.link?.length !== 0 || props?.downloadData?.trackWindows64?.link?.length !== 0 || props?.downloadData?.trackMac?.link?.length !== 0 || props?.downloadData?.trackLinux?.link?.length !== 0) &&
                <div className="u_download-wpr">

                    <div className="u_download-header">
                        <h5>Super Track - Desktop App</h5>
                    </div>

                    <div className="u_download-section">
                        {(props?.downloadData?.trackWindows32?.link?.length !== 0 || props?.downloadData?.trackWindows64?.link?.length !== 0) && <div className="u_download-block">
                            <div className="u_download-block-icon">
                                <Icon.WindowsColor size={34}/>
                            </div>
                            <p>Windows</p>
                            <div className="u_download-version">
                                <button className="u_download-block-btn" onClick={() => openList("track")}>
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                    <span className="u_download-block-arrow"><Icon.DownArrow fill="#007AFF" size={12}/></span>
                                </button>

                                <ul className="u_hidden u_download-version-list u_download-version-track">
                                    {
                                        props?.downloadData?.trackWindows32?.link?.length !== 0 && <li>
                                            <a href="javascript:;" onClick={() => downloadLink(props?.downloadData?.trackWindows32?.link)}>
                                                <span> <Icon.Windows fill="#4E525F" size={14}/></span>
                                                Windows 32
                                            </a>
                                        </li>
                                    }
                                    {
                                        props?.downloadData?.trackWindows64?.link?.length !== 0 && <li>
                                            <a href="javascript:;" onClick={() => downloadLink(props?.downloadData?.trackWindows64?.link)}>
                                                <span> <Icon.Windows fill="#4E525F" size={14}/></span>
                                                Windows 64
                                            </a>
                                        </li>
                                    }
                                </ul>
                            </div>

                        </div>}
                        {
                            props?.downloadData?.trackMac?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.Apple fill="#1E2538" size={34}/>
                                </div>
                                <p>Mac</p>
                                <a href={props?.downloadData?.trackMac?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }

                        {
                            props?.downloadData?.trackLinux?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.Linux size={34}/>
                                </div>
                                <p>Linux</p>
                                <a href={props?.downloadData?.trackLinux?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                    </div>
                </div>
                }

                {(props?.downloadData?.androidChat?.link?.length !== 0 || props?.downloadData?.androidHRMS?.link?.length !== 0 || props?.downloadData?.androidPMS?.link?.length !== 0) &&
                <div className="u_download-wpr">

                    <div className="u_download-header">
                        <h5>Android App</h5>
                    </div>

                    <div className="u_download-section">
                        {
                            props?.downloadData?.androidChat?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.UbsChat size={30}/>
                                </div>
                                <p>Chat</p>
                                <a href={props?.downloadData?.androidChat?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                        {
                            props?.downloadData?.androidHRMS?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.HRMS size={30}/>
                                </div>
                                <p>HRMS</p>
                                <a href={props?.downloadData?.androidHRMS?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                        {
                            props?.downloadData?.androidPMS?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.PMS size={30}/>
                                </div>
                                <p>PMS</p>
                                <a href={props?.downloadData?.androidPMS?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                    </div>
                </div>
                }

                {(props?.downloadData?.iosChat?.link?.length !== 0 || props?.downloadData?.iosHRMS?.link?.length !== 0 || props?.downloadData?.iosPMS?.link?.length !== 0) &&
                <div className="u_download-wpr">

                    <div className="u_download-header">
                        <h5>iOS App</h5>
                    </div>

                    <div className="u_download-section">
                        {
                            props?.downloadData?.iosChat?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.UbsChat size={30}/>
                                </div>
                                <p>Chat</p>
                                <a href={props?.downloadData?.iosChat?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                        {
                            props?.downloadData?.iosHRMS?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.HRMS size={30}/>
                                </div>
                                <p>HRMS</p>
                                <a href={props?.downloadData?.iosHRMS?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                        {
                            props?.downloadData?.iosPMS?.link?.length !== 0 &&
                            <div className="u_download-block">
                                <div className="u_download-block-icon">
                                    <Icon.PMS size={30}/>
                                </div>
                                <p>PMS</p>
                                <a href={props?.downloadData?.iosPMS?.link} className="u_download-block-btn" target="_blank">
                                    <span> <Icon.Download fill="#007AFF" size={14}/></span>
                                    Download
                                </a>
                            </div>
                        }
                    </div>
                </div>
                }

                </div>
                : ''
            }

        </React.Fragment>
    )
}

export default UDownload;
